module.exports = __webpack_public_path__ + "static/media/AZ.793d9753.png";